import React from 'react';
import { BrowserRouter as Router, Routes, Route, Navigate, Link } from 'react-router-dom';
import { AuthProvider, useAuth } from './context/AuthContext';
import QuestionList from './components/QuestionList';
import CreateQuestion from './components/CreateQuestion';
import QuestionDetail from './components/QuestionDetail';
import Login from './components/Login';
import Signup from './components/Signup';
import './App.css';

const PrivateRoute: React.FC<{ children: React.ReactElement }> = ({ children }) => {
  const { isAuthenticated } = useAuth();
  return isAuthenticated ? children : <Navigate to="/login" />;
};

const Header: React.FC = () => {
  const { isAuthenticated, user, logout } = useAuth();

  return (
    <header className="app-header">
      <div className="header-content">
        <Link to="/" className="app-title">
          <h1>Correlation Analyzer</h1>
        </Link>
        {isAuthenticated && (
          <div className="header-user">
            <span className="user-email">{user?.email}</span>
            <button onClick={logout} className="btn btn-secondary btn-sm">
              Logout
            </button>
          </div>
        )}
      </div>
    </header>
  );
};

function App() {
  return (
    <AuthProvider>
      <Router>
        <div className="App">
          <Header />
          <Routes>
            <Route path="/login" element={<Login />} />
            <Route path="/signup" element={<Signup />} />
            <Route
              path="/"
              element={
                <PrivateRoute>
                  <QuestionList />
                </PrivateRoute>
              }
            />
            <Route
              path="/questions/new"
              element={
                <PrivateRoute>
                  <CreateQuestion />
                </PrivateRoute>
              }
            />
            <Route
              path="/questions/:id"
              element={
                <PrivateRoute>
                  <QuestionDetail />
                </PrivateRoute>
              }
            />
          </Routes>
        </div>
      </Router>
    </AuthProvider>
  );
}

export default App;
